import { Link } from "react-router-dom";
import { Seo } from "../lib/seo";

export default function PaymentCancel() {
  return (
    <>
      <Seo title="Payment not completed | 80 Metrics" robots="noindex, nofollow" />
      <section className="bg-charcoal text-ivory min-h-[60vh]" data-testid="payment-cancel-page">
        <div className="max-w-3xl mx-auto px-6 lg:px-10 py-20 lg:py-28">
          <p className="text-xs font-semibold tracking-[0.28em] uppercase text-gold">Checkout cancelled</p>
          <h1 className="mt-6 font-serif text-3xl sm:text-4xl lg:text-5xl font-medium leading-tight">
            Your payment wasn’t completed.
          </h1>
          <p className="mt-6 text-sm lg:text-base text-ivory/60 leading-relaxed max-w-xl">
            Nothing has been charged. Your question is worth answering properly — you can pick up your SuburbIQ order where you left off.
          </p>
          <Link
            to="/suburbiq"
            data-testid="cancel-return-link"
            className="mt-10 inline-flex px-8 py-4 bg-gold text-ink text-xs font-semibold tracking-[0.2em] uppercase transition-[background-color] duration-300 hover:bg-ivory"
          >
            Return to SuburbIQ
          </Link>
        </div>
      </section>
    </>
  );
}
